import API from './api';

export const getPortfolio = (studentUuid) =>
  API.get(`/auth/portfolios/${studentUuid}/`).then((response) => response.data);

export const updatePortfolio = (studentUuid, payload) =>
  API.patch(`/auth/portfolios/${studentUuid}/`, payload).then((response) => response.data);

export const createPortfolioEntry = (payload) =>
  API.post('/auth/portfolio_entries/', payload).then((response) => response.data);
export const updatePortfolioEntry = (uuid, payload) =>
  API.patch(`/auth/portfolio_entries/${uuid}/`, payload).then((response) => response.data);
export const deletePortfolioEntry = (uuid) => API.delete(`/auth/portfolio_entries/${uuid}/`);

export const createPortfolioProject = (payload) =>
  API.post('/auth/portfolio_projects/', payload).then((response) => response.data);
export const updatePortfolioProject = (uuid, payload) =>
  API.patch(`/auth/portfolio_projects/${uuid}/`, payload).then((response) => response.data);
export const deletePortfolioProject = (uuid) => API.delete(`/auth/portfolio_projects/${uuid}/`);

export const uploadPortfolioEvidence = (payload) => {
  const data = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') data.append(key, value);
  });
  return API.post('/auth/portfolio_evidence/', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((response) => response.data);
};
export const confirmPortfolioEvidence = (uuid, payload) =>
  API.post(`/auth/portfolio_evidence/${uuid}/confirm/`, payload).then((response) => response.data);
export const rejectPortfolioEvidence = (uuid, expected_version) =>
  API.post(`/auth/portfolio_evidence/${uuid}/reject/`, { expected_version }).then((response) => response.data);
export const reanalyzePortfolioEvidence = (uuid, expected_version) =>
  API.post(`/auth/portfolio_evidence/${uuid}/reanalyze/`, { expected_version }).then((response) => response.data);
export const deletePortfolioEvidence = (uuid) => API.delete(`/auth/portfolio_evidence/${uuid}/`);
